import { isNumber } from '#helper/format';
import i18n from '#locale/index';

export const formatNumber = (val: string | number | boolean | null | undefined) => {
    if(typeof val === 'boolean' || !isNumber(val)) {
        return '';
    }

    return i18n.t('intlNumber', { val });
};

export const roundNumber = (value: number) => Math.round(((value) * 100)) / 100;
